import { Pipe, PipeTransform } from '@angular/core';
import { NzTreeNodeOptions } from 'ng-zorro-antd/tree';

@Pipe({
  name: 'filterTreeNodes'
})
export class MFilterTreeNodesPipe implements PipeTransform {
  transform(tree: NzTreeNodeOptions[], searchValue?: string, keyName: string = 'title'): NzTreeNodeOptions[] {
    if (!searchValue || !searchValue.trim()) {
      return tree;
    }
    const result = this.loopSearch(JSON.parse(JSON.stringify(tree)), searchValue, keyName);
    return result;
  }

  loopSearch(tree: NzTreeNodeOptions[], searchValue?: string, keyName: string = 'title'): NzTreeNodeOptions[] {
    const newTree = tree
      .filter(node => {
        if (node[keyName] && node[keyName].indexOf(searchValue) > -1) {
          return true;
        } else if (node.children) {
          node.children = this.loopSearch(JSON.parse(JSON.stringify(node.children)), searchValue, keyName);
          return node.children.length > 0;
        } else {
          return false;
        }
      })
      .map(node => {
        node.expanded = true;
        return node;
      });
    return newTree;
  }
}
